import Banner from '../../sections/common/banner';
import { data } from '../../../globals/data/metals';
import SectionServices2 from '../../sections/home/index2/section-services2';
import SectionWhyChooseUs2 from '../../sections/home/index2/section-why-choose-us2';
import ServicesPageHelmet from '../../helmets/ServicesPageHelmet';

export default function MetalsPage() {
  return (
    <>
      <ServicesPageHelmet />

      <Banner _data={data.banner} />
      <SectionWhyChooseUs2 _data={data.whychoosus} />
      <SectionServices2 _data={data.services} />
    </>
  );
}
